<template>
  <div>
    <PageHeaderLayout>
      <div class="main-page-content">
        <el-row class="table-header">
          <el-col>
            <el-tooltip effect="dark" content="添加用户" placement="top-start"  v-if="userPermissions.indexOf('user_create') != -1 && buttonType=='icon'" >
              <el-button type="primary" size="medium" icon="iconfont icon-tianjiacaidan2" @click="addButton(0)"></el-button>
            </el-tooltip>
            <el-button type="primary" size="medium"  v-if="userPermissions.indexOf('user_create') != -1 && buttonType=='text'" @click="addButton(0)">添加</el-button>
          </el-col>
        </el-row>
        <el-row class="table-search">
          <el-form size="medium" :inline="true" :model="searchCondition" class="demo-form-inline">
            <el-form-item label="姓名">
              <el-input v-model="searchCondition.fullname" placeholder="输入姓名" clearable></el-input>
            </el-form-item>
            <el-form-item label="手机号">
              <el-input v-model="searchCondition.mobile" placeholder="输入手机号" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="searchButton">查询</el-button>
            </el-form-item>
          </el-form>
        </el-row>
        <ApeTable ref="apeTable" :data="userList" :columns="columns" :loading="loadingStaus" :pagingData="pagingData" @switchPaging="switchPaging" highlight-current-row >
          <el-table-column
            v-if="buttonType=='icon'"
            align="center"
            label="操作">
            <template slot-scope="scope">
              <el-tooltip effect="dark" content="编辑" placement="top-start"  v-if="userPermissions.indexOf('user_edit') != -1" >
                <el-button size="mini" icon="el-icon-edit" @click="editButton(scope.row.id)"></el-button>
              </el-tooltip>
              <el-tooltip effect="dark" content="删除" placement="top-start">
                <span>
                  <el-popover
                    v-if="userPermissions.indexOf('user_delete') != -1"
                    placement="top"
                    width="150"
                    v-model="scope.row.visible">
                    <p>确定要删除记录吗？</p>
                    <div style="text-align: right; margin: 0;">
                      <el-button type="text" size="mini" @click="scope.row.visible=false">取消</el-button>
                      <el-button type="danger" size="mini" @click="deleteButton(scope.row.id)">确定</el-button>
                    </div>
                    <el-button slot="reference" type="danger" size="mini" icon="el-icon-delete"></el-button>
                  </el-popover>
                </span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            v-if="buttonType=='text'"
            align="center"
            label="操作">
            <template slot-scope="scope">
              <span>
                <el-button size="mini"  v-if="userPermissions.indexOf('user_edit') != -1" @click="editButton(scope.row.id)">编辑</el-button>
                <el-popover
                  v-if="userPermissions.indexOf('user_delete') != -1"
                  placement="top"
                  width="150"
                  v-model="scope.row.visible">
                  <p>确定要删除记录吗？</p>
                  <div style="text-align: right; margin: 0;">
                    <el-button type="text" size="mini" @click="scope.row.visible=false">取消</el-button>
                    <el-button type="danger" size="mini" @click="deleteButton(scope.row.id)">确定</el-button>
                  </div>
                  <el-button slot="reference" type="danger" size="mini" >删除</el-button>
                </el-popover>
              </span>
            </template>
          </el-table-column>
        </ApeTable>
      </div>
    </PageHeaderLayout>

    <ApeDrawer :drawerData="drawerData"  @drawerClose="drawerClose" @drawerConfirm="drawerConfirm">
      <template slot="ape-drawer">
        <el-form :model="formData" :rules="rules" ref="userForm" label-position="right" label-width="96px">
          <el-row>
            <el-col :span="22">
              <el-form-item label="手机号" prop="mobile">
                <el-input v-model="formData.mobile"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="姓名" prop="fullname">
                <el-input v-model="formData.fullname"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="Email" prop="email">
                <el-input v-model="formData.email"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="密码" prop="password">
                <el-input v-model="formData.password">
                  <template slot="append">
                    <el-button type="primary" @click="randSecret" icon="el-icon-refresh-right" id="generate">
                      生成SECRET
                    </el-button>
                  </template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="角色绑定" prop="user_roles">
                <el-select v-model="formData.user_roles" multiple filterable clearable placeholder="请选择">
                  <el-option
                    v-for="item in rolesList"
                    :key="item.id"
                    :label="item.display_name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="公司绑定" prop="user_company">
                <el-select v-model="formData.user_company" multiple filterable placeholder="请选择">
                  <el-option
                    v-for="item in companyList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="服务公司绑定" prop="user_settlement">
                <el-select v-model="formData.user_settlement" multiple filterable placeholder="请选择">
                  <el-option
                    v-for="item in settlementList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </template>
    </ApeDrawer>
  </div >
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import ApeDrawer from '@/components/ApeDrawer'
import { mapGetters } from 'vuex'

export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    ApeDrawer,
  },
  data() {
    return {
      // 搜索条件
      searchCondition:{},
      loadingStaus: true,
      columns: [
        {
          title: 'ID',
          value: 'id',
          header_align: 'center',
          align: 'center',
        },
        {
          title: '手机号',
          value: 'mobile',
          header_align: 'center',
          align: 'center',
        },
        {
          title: '姓名',
          value: 'fullname',
          header_align: 'center',
          align: 'center',
        },
        {
          title: '状态',
          header_align: 'center',
          /* align: 'center', */
          width: 300,
          value: [
            {label:'创建时间：', width: 100, value:'created_at'},
            {label:'最近登录时间：', width: 100, value:'last_login_at'},
            {label:'用户IP：', width: 100, value:'last_ip'},
            {label:'成功次数：',width: 100, value:'login_times'},
            {label:'失败次数：',width: 100, value:'retry_time'},
          ],
        },
        // {
        //   title: '时间',
        //   value: 'created_at',
        //   header_align: 'center',
        //   align: 'center',
        // },
      ],
      // 表格列表数据
      userList:[],
      // 分页信息
      pagingData:{
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0
      },
      // 分页的offset,序号列使用
      offset:0,
      // 表单结构
      formData: {
        password: "",
        user_roles: []
      },
      // 表单验证
      rules: {
        mobile: [
          {required: true, message: '输入手机号', trigger: 'blur' },
          // {pattern: this.$utils.regular.mobile,message:'手机号格式错误', trigger: 'blur' }
        ],
        password:[
          {
            min:6,message:"请输入6位以上密码"
          },
          {
            pattern: /^(?![A-Za-z]+$)(?![A-Z\d]+$)(?![A-Z\W]+$)(?![a-z\d]+$)(?![a-z\W]+$)(?![\d\W]+$)\S{6,}$/ ,  message: '请输入包含数字、字母、特殊字符正确格式的密码', trigger: 'blur' 
          }
        ],
        fullname: [
          {required: true, message: '输入姓名', trigger: 'blur' },
        ],
      },
      // 抽屉数据
      drawerData: {
        visible: false,
        loading: true,
        loading_text: '正在加载中……',
        // direction: 'right',
        title: '权限绑定',
        width_height: '480px',
        // mask: false,
        // close_name: '关 闭',
        // confirm_name: '打 印',
      },

      // 用户绑定角色
      rolesList: [],
      userRoles: [],

      // 用户绑定公司
      companyList: [],
      userCompany: [],

      // 用户绑定服务公司
      settlementList: [],
      userSettlement: [],

    }
  },
  computed: {
    ...mapGetters(['userPermissions','buttonType'])
  },
  methods: {
    // 生成SECRET
    randSecret(e) {
      let secret = this.$utils.randomString(6)
      console.log('pass1 -> ', this.formData.password)
      this.formData.password = secret
      console.log('pass2 -> ', this.formData.password)
      console.log('e -> ', e)
    },
    // 搜索
    searchButton() {
      this.initUserList()
    },
    // 切换页码操作
    async switchPaging() {
      this.initUserList()
    },
    // 响应添加按钮
    async addButton() {
      this.drawerData.loading_text = '正在加载中……'
      this.drawerData.visible = true
      this.drawerData.title = '添加用户'
      this.rolesList = await this.$api.getUserRoles()
      this.companyList = await this.$api.getCompanyCategoryList()
      this.settlementList = await this.$api.getSettlementCategoryList()
      this.$nextTick(() => {
        this.drawerData.loading = false
      })
    },
    // 响应编辑按钮
    async editButton(id) {
      this.drawerData.loading_text = '正在加载中……'
      this.drawerData.visible = true
      this.drawerData.title = '编辑用户(UID：'+id+')'
      this.rolesList = await this.$api.getUserRoles()
      this.companyList = await this.$api.getCompanyCategoryList()
      this.settlementList = await this.$api.getSettlementCategoryList()
      let {info} = await this.$api.getUserInfo(id)
      console.log("editButton->info", info);
      this.formData = info
      this.drawerData.loading = false
    },
    // 处理抽屉关闭
    drawerClose() {
      this.initFormData()
      this.drawerData.visible = false
      this.drawerData.loading = true
      this.rolesList = []
    },
    // 处理抽屉确认
    async drawerConfirm() {
      // 调用组件的数据验证方法
      this.$refs['userForm'].validate((valid) => {
        if (valid) {
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    // form数据提交，请求接口
    async formSubmit() {
      this.drawerData.loading_text = '正在提交中……'
      this.drawerData.loading = true
      let id = await this.$api.saveUser(this.formData)
      this.$nextTick(() => {
        this.drawerData.visible = false
      })
      this.$nextTick(async () => {
        if (id) {
          this.initUserList()
        }
      })
      this.$nextTick(() => {
        this.$message.success('保存成功!')
      })
      this.initFormData()
    },
    // 相应删除按钮
    async deleteButton(id) {
      let info = await this.$api.deleteUser(id)
      if (info == 'ok') {
        this.$nextTick(async () => {
          this.initUserList('del')
        })
      } else {
        this.$message.error(info)
      }

    },
    // 初始化数据
    initFormData() {
      // 初始化form表单
      this.$nextTick(() => {
        this.formData = {user_roles: [], password: ''}
        this.$refs['userForm'].resetFields()
      })
    },
    // 初始化用户列表
    async initUserList(type) {
      this.loadingStaus=true
      let pagingInfo = this.$refs['apeTable'].getPagingInfo(type)
      let searchCondition = this.searchCondition
      // 合并
      Object.assign(searchCondition,pagingInfo)
      let {list,pages}= await this.$api.getUserList(searchCondition)
      this.userList=list
      this.pagingData.total = pages.total
      this.offset = pages.offset
      this.loadingStaus=false
    }
  },
  mounted() {
    this.initUserList()
  },
}
</script>

<style lang="stylus" scoped>
  .el-button
    margin-right 4px
    margin-bottom 4px
  .table-header
    margin-bottom 12px
  .drag-handle
    font-size 24px
    cursor pointer
  .el-popover .el-checkbox-group .el-checkbox
    margin-left 0px
    margin-right 12px
  .el-select > .el-input
    width 300px
  #generate {
    margin-bottom: -10px;
    margin-left: 4px;
  }
  // .table-search
  //   height: 36px
</style>
